export type PropertyChildInput = {
  floor: string;
  apartment_number: string;
  /** Optional tower/block label (max 50 on the API). */
  tower_block?: string;
};

export type PropertyChild = {
  id: number;
  parent_property_id: number | null;
  apartment_number: string;
  floor: string;
  tower_block: string;
  unit_reference: string;
  is_rented: boolean;
};

export const PARENT_HAS_AVAILABLE_CHILDREN_CODE =
  "PARENT_HAS_AVAILABLE_CHILDREN" as const;

export type ParentHasAvailableChildrenError = {
  code: typeof PARENT_HAS_AVAILABLE_CHILDREN_CODE;
  availableChildrenCount: number;
  message: string;
};

export const TOWER_BLOCK_MAX_LENGTH = 50;
